module.exports = __webpack_public_path__ + "img/img-music.7005b70d.jpg";